import type {SaasPlan} from '../types';

type PublicPricePlan = Pick<SaasPlan, 'priceMonthly' | 'priceYearly' | 'currency'>;
const valid = (value: unknown): value is number => typeof value === 'number' && Number.isFinite(value) && value >= 0;

/** Presentation only: never changes the amount stored or charged by a plan. */
export function publicPlanPrice(plan: PublicPricePlan, preferYearly = false): {
  main: string; sub?: string; amount: number | null; period: 'month' | 'year' | null;
} {
  const monthly = valid(plan.priceMonthly), yearly = valid(plan.priceYearly);
  const annual = yearly && (preferYearly || !monthly);
  const amount = annual ? plan.priceYearly! : monthly ? plan.priceMonthly : null;
  if (amount === null) return {main:'Consultar precio', amount:null, period:null};
  const period = annual ? 'year' : 'month';
  const currency = plan.currency || 'EUR';
  // The public catalog admits cents, including for ISO currencies with a
  // different default minor unit; preserve the published two decimal places.
  const options = {minimumFractionDigits:Number.isInteger(amount) ? 0 : 2, maximumFractionDigits:2};
  const main = amount === 0 ? 'Gratis' : /^[A-Z]{3}$/.test(currency)
    ? new Intl.NumberFormat('es-ES', {...options,style:'currency',currency}).format(amount)
    : `${new Intl.NumberFormat('es-ES',options).format(amount)} ${currency}`;
  return {main, sub:annual ? '/año' : '/mes', amount, period};
}
